import { createUrl } from "./urlQueryHelper.js";

export function saveDataListState(page, rowsPerPage, dataListFilter, dataListSort) {
  if (!history.pushState) {
    return;
  }
  const newurl = createUrl(page, rowsPerPage, dataListFilter, dataListSort);
  window.history.pushState({ path: newurl }, "", newurl);
}